module.exports = __webpack_public_path__ + "img/pencil-line.33a57933.svg";